import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=37d4461a&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"
import style0 from "./Research.vue?vue&type=style&index=0&id=37d4461a&prod&lang=less&scoped=true"
import style1 from "./Research.vue?vue&type=style&index=1&id=37d4461a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4461a",
  null
  
)

export default component.exports